import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from '@/store.js';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [ // corrige a primeira abertura mas quebra as rotas
        // {   
        //     path: '/index.html',
        //     component: () => import('./views/Menu.vue'),
        //     alias: '/'
        // },
        {
            path: '/',
            name: 'menu',
            component: () => import('./views/Menu.vue'),
            meta: {
                authRequired: true
            }
            //name: 'home',
            //component: Home
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./views/About.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/menu',
            name: 'menu',
            component: () => import('./views/Menu.vue'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/sign-in',
            name: 'signin',
            component: () => import('./views/Signin.vue')
        },
        {
            path: '/join',
            name: 'join',
            component: () => import('./views/Join.vue')
        },
        {
            path: '/cadastro-usuarios-Listagem',
            name: 'Cadastro-Usuarios-Listagem',
            component: () => import('./views/auth/cadastro/usuarios/Cadastro-Usuarios-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cadastro-usuarios-adicionar',
            name: 'Cadastro-Usuarios-Adicionar',
            component: () => import('./views/auth/cadastro/usuarios/Cadastro-Usuarios-Adicionar'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cadastro-usuarios-editar',
            name: 'Cadastro-Usuarios-Editar',
            component: () => import('./views/auth/cadastro/usuarios/Cadastro-Usuarios-Editar'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cadastro-usuarios-adicionar-admin',
            name: 'Cadastro-Usuarios-Adicionar-Admin',
            component: () => import('./views/auth/cadastro/usuarios/Cadastro-Usuarios-Adicionar-Admin'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/cadastro-usuarios-adicionar-escola',
            name: 'Cadastro-Usuarios-Adicionar-Escola',
            component: () => import('./views/auth/cadastro/usuarios/Cadastro-Usuarios-Adicionar-Escola'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/perfil',
            name: 'Perfil',
            component: () => import('./views/auth/cadastro/usuarios/Perfil'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-post',
            name: 'Criar-Post',
            component: () => import('./views/auth/funcionalidades/postagens/Criar-Post'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-post',
            name: 'Editar-Post',
            component: () => import('./views/auth/funcionalidades/postagens/Editar-Post'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-comunicado',
            name: 'Criar-Comunicado',
            component: () => import('./views/auth/funcionalidades/comunicados/Criar-Comunicado'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/comunicados-listagem',
            name: 'Comunicados-Listagem',
            component: () => import('./views/auth/funcionalidades/comunicados/Comunicados-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-comunicado',
            name: 'Editar-Comunicado',
            component: () => import('./views/auth/funcionalidades/comunicados/Editar-Comunicado'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-cardapio',
            name: 'Editar-Cardapio',
            component: () => import('./views/auth/funcionalidades/cardapio/Editar-Cardapio'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/display-cardapio',
            name: 'Display-Cardapio',
            component: () => import('./views/auth/funcionalidades/cardapio/Display-Cardapio'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-lembrete-medicacao',
            name: 'Criar-Lembrete-Medicacao',
            component: () => import('./views/auth/funcionalidades/saude/Criar-Lembrete-Medicacao'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-lembrete-medicacao',
            name: 'Editar-Lembrete-Medicacao',
            component: () => import('./views/auth/funcionalidades/saude/Editar-Lembrete-Medicacao'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/lembrete-medicacao-listagem',
            name: 'Lembrete-Medicacao-Listagem',
            component: () => import('./views/auth/funcionalidades/saude/Lembrete-Medicacao-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/meus-alunos',
            name: 'Meus-Alunos',
            component: () => import('./views/auth/funcionalidades/turmas/Meus-Alunos'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-diario',
            name: 'Criar-Diario',
            component: () => import('./views/auth/funcionalidades/resumo-diario/Criar-Diario'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-diario',
            name: 'Editar-Diario',
            component: () => import('./views/auth/funcionalidades/resumo-diario/Editar-Diario'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/resumo-diario-listagem',
            name: 'Resumo-Diario-Listagem',
            component: () => import('./views/auth/funcionalidades/resumo-diario/Resumo-Diario-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-evento',
            name: 'Criar-Evento',
            component: () => import('./views/auth/funcionalidades/eventos/Criar-Evento'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-evento',
            name: 'Editar-Evento',
            component: () => import('./views/auth/funcionalidades/eventos/Editar-Evento'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/eventos-listagem',
            name: 'Eventos-Listagem',
            component: () => import('./views/auth/funcionalidades/eventos/Eventos-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-ocorrencia',
            name: 'Criar-Ocorrencia',
            component: () => import('./views/auth/funcionalidades/ocorrencias/Criar-Ocorrencia'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-ocorrencia',
            name: 'Editar-Ocorrencia',
            component: () => import('./views/auth/funcionalidades/ocorrencias/Editar-Ocorrencia'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/ocorrencias-listagem',
            name: 'Ocorrencias-Listagem',
            component: () => import('./views/auth/funcionalidades/ocorrencias/Ocorrencias-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/mensagens-listagem',
            name: 'Mensagens-Listagem',
            component: () => import('./views/auth/funcionalidades/mensagens/Mensagens-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/chat',
            name: 'Chat',
            component: () => import('./views/auth/funcionalidades/mensagens/Chat'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/dashboard-aluno',
            name: 'Dashboard-Aluno',
            component: () => import('./views/auth/funcionalidades/dashboard/Dashboard-Aluno'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/dashboard-escola',
            name: 'Dashboard-Escola',
            component: () => import('./views/auth/funcionalidades/dashboard/Dashboard-Escola'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/criar-turma',
            name: 'Criar-Turma',
            component: () => import('./views/auth/funcionalidades/turmas/Criar-Turma'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/editar-turma',
            name: 'Editar-Turma',
            component: () => import('./views/auth/funcionalidades/turmas/Editar-Turma'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/turmas-listagem',
            name: 'Turmas-Listagem',
            component: () => import('./views/auth/funcionalidades/turmas/Turmas-Listagem'),
            meta: {
                authRequired: true
            }
        },
        ,
        {
            path: '/criar-enquete',
            name: 'Criar-Enquete',
            component: () => import('./views/auth/funcionalidades/enquete/Criar-Enquete'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/enquete-listagem',
            name: 'Enquete-Listagem',
            component: () => import('./views/auth/funcionalidades/enquete/Enquete-Listagem'),
            meta: {
                authRequired: true
            }
        },
        {
            path: '/site',
            name: 'site',
            component: () => import('./views/open/site')
        },
        {
            path: '/blog',
            name: 'blog',
            component: () => import('./views/open/blog')
        },
        {
            path: '/blog/idade-para-aprender-ingles',
            name: 'idade-para-aprender-ingles',
            component: () => import('./views/open/idade-para-aprender-ingles'),
            meta: {
                title: 'About Page - Example App',
                metaTags: [
                  {
                    name: 'description',
                    content: 'The about page of our example app.'
                  },
                  {
                    property: 'og:description',
                    content: 'The about page of our example app.'
                  }
                ]
              }
        },
        {
            path: '/blog/vagas-educacao-infantil-janeiro-2020',
            name: 'vagas-educacao-infantil-janeiro-2020',
            component: () => import('./views/open/vagas-educacao-infantil-janeiro-2020')
        },
        {
            path: '/blog/sustentabilidade-creches-escolas',
            name: 'sustentabilidade-creches-escolas',
            component: () => import('./views/open/sustentabilidade-creches-escolas')
        }
        
        
    ]
});



router.beforeEach((to, from, next) => {
    
    //console.log("xxxxxxxxxxxxxxxxxxxx");
    //console.log(to);
    //console.log(to.path.indexOf('blog'))
    //console.log(to.path.indexOf('menu'))
    // Google Analytics
    gtag('config', 'UA-151323970-1', {
        'page_title' : to.name,
        'page_path': to.fullPath
    });
    if (to.matched.some(record => record.meta.authRequired)) {
        
        var setIsAuthenticated = localStorage.getItem('setIsAuthenticated'); // customização minha para ler o session storage

        if(to.fullPath.indexOf('blog') < 0 && to.fullPath.indexOf('menu') < 0){ // if para fazer as rodas do blog
            // PRODUCAO
            if (window.location.href.indexOf("version=reactmobile") > 0) {
                next({
                    path: '/site'
                });
            }
            else if (!window.matchMedia('(display-mode: standalone)').matches) {// Se for web / mobile web redireciona para o site
                next({
                    path: '/site'
                });
            }
            else if (window.navigator.standalone === false) {
                next({
                    path: '/site'
                });
            }
            else if(!store.state.isAuthenticated && !setIsAuthenticated){
                next({
                    path: '/sign-in'
                });
            } 
            else {
                next();
            }


            // DEV
            // if(!store.state.isAuthenticated && !setIsAuthenticated){
            //     next({
            //         path: '/sign-in'
            //     });
            // } 
            // else {
            //     next();
            // }

            // if(!store.state.isAuthenticated && !setIsAuthenticated){
            //     next({
            //         path: '/sign-in'
            //     });
            // } 
            // else {
            //     next();
            // }

        }
        
        
    } else {
        next();
    }
});


export default router;